import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {MyOverlayRef} from '@app/core/components/overlay/myoverlay-ref';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: "app-login-alert",
  imports: [CommonModule, TranslateModule],
  templateUrl: "./login-alert.component.html",
  standalone: true,
  styleUrls: ["./login-alert.component.scss"],

})
export class LoginAlertComponent implements OnInit {
  showGuestBtn: boolean = false;
  constructor(
    private readonly router: Router,
    private dialogRef: MyOverlayRef
  ) {
    this.showGuestBtn = this.dialogRef.data?.showGuestBtn ?? false;
  }

  ngOnInit(): void {}
  onSiginIn() {
    this.dialogRef.close();
    this.router.navigate(['/login']).then();
  }
  onRegister() {
    this.dialogRef.close();
    this.router.navigate(['/register']).then();
  }
  onContinueAsGuest() {
    this.dialogRef.close('ContinueAsGuest');
  }
}
